import { useContext, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import LoadingWheel from "../../common/LoadingWheel";
import { GlobalContext } from "../../common/Context";
import { useTranslation } from "react-i18next";
import PeopleIcon from "@mui/icons-material/People";
import EventIcon from "@mui/icons-material/Event";
import moment from "moment";
import CompetitionDDL from "../SafeRoads/components/CompetitionDDL";
import ReBox from "../../common/ReBox";
import InfoModal from "./components/InfoModal";
import SelfImprovement from "./components/SelfImprovement";
import MoneyPot from "./components/MoneyPot";
import GrandPrizeArea from "./components/GrandPrizeArea";
import { green, white } from "../../../theme/colours";
import ErrorNoCompPage from "../../common/ErrorNoCompPage";
import ChallengesDisplay from "./components/ChallengesDisplay/ChallengesDisplay";
import {
  InfoModalButtonOptions,
  SponsoredPrizeCompetition,
  SPONSORED_PRIZES,
  SponsoredPrizeBanners,
} from "./components/CompetitionInfoFixtures/CompetitionInfoFixtures";
import {
  CHALLENGES_MAIN_AREA,
  CHALLENGES_NO_COMP_ERROR,
} from "../../../constants/ids";

const CompetitionInfo = () => {
  const { t } = useTranslation("CompetitionInfo");
  const {
    userState,
    firebaseState,
    mobileView,
    tabletView,
    desktopView,
    competitionList,
  } = useContext(GlobalContext);

  const [currCompetition, setCurrCompetition] = useState();
  const [gpInfo, setGPInfo] = useState();
  const [totalUsers, setTotalUsers] = useState();
  const [banners, setBanners] = useState();
  const [currentBanners, setCurrentBanners] = useState({
    main: null,
    prize: null,
  });

  const [activeCampData, setActiveCampData] = useState();
  const [selfImprovementData, setSelfImprovementData] = useState();
  const [poolData, setPoolData] = useState();
  const [winnerCampData, setWinnerCampData] = useState();
  const [corporateCampaignData, setCorporateCampaignData] = useState();

  const [descRef, setDescRef] = useState(null);
  const [openDialog, setOpenDialog] = useState(-1);
  const [dialogInfo, setDialogInfo] = useState({ comp: {}, prize: {} });
  const [rerender, setRerender] = useState(false);
  const [error, setError] = useState(false);

  const verifyBannersLoad = () => {
    if (banners === undefined) {
      return false;
    }
    if (banners === false) {
      return true;
    }

    return !!currentBanners.main;
  };

  const renderMainEmpty = () => {
    currCompetition && Object.keys(currCompetition?.iteration).length === 0;
  };

  const renderMain = () => {
    return currCompetition?.iteration && verifyBannersLoad();
  };

  const renderGP = () => {
    return !!(gpInfo?.length > 0);
  };

  const reset = () => {
    setWinnerCampData(null);
    setActiveCampData(null);
    setTotalUsers();
    setGPInfo(null);
    setBanners();
    setCurrentBanners({ main: null, prize: null });
    setSelfImprovementData(null);
    setPoolData(null);
    setCorporateCampaignData(null);
  };

  const containerStyle = {
    width: "100%",
    height: "inherit",
    mt: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };
  const upperBoxStyle = {
    display: "flex",
    flexDirection: tabletView || mobileView ? "column" : "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    width: "100%",
  };
  const challengeAreaStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width:
      tabletView || mobileView || (renderMain() && !renderGP())
        ? "100%"
        : "66%",
    mb: tabletView || mobileView ? "2rem" : "0",
    height:
      desktopView &&
      (renderGP() || renderMainEmpty() || !renderMain()) &&
      "25rem",
    background: !renderMain() && white,
    borderRadius: "12px",
    boxShadow: !renderMain() && "0px 2px 3px 1px #dad8e8",
  };
  const textIconStyle = {
    ml: "0.5rem",
    color: green[2],
    fontSize: "1rem",
  };
  const emptyTextStyle = {
    fontWeight: 500,
  };
  const gpTextStyle = {
    mt: !mobileView && "0.5rem",
    mb: tabletView ? "0.75rem" : "1rem",
    fontSize: desktopView ? "1.25rem" : "1rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
  const upperContentStyle = {
    padding: mobileView || tabletView ? "0.25rem 1rem" : "0.5rem 2rem",
    borderRadius: "0 0 1rem 1rem",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    flex: 1,
    ...(!desktopView
      ? {
          background: "none",
          boxShadow: "none",
          p: 0,
        }
      : {}),
    ...(currCompetition?.iteration?.id === SPONSORED_PRIZES && {
      flexDirection: "row-reverse",
      justifyContent: "space-between",
    }),
  };
  const upperHeaderInfoStyle = {
    display: "flex",
    flexDirection: mobileView ? "column-reverse" : "row",
    alignContent: "flex-start",
    justifyContent: "space-between",
    alignItems: "center",
    height: desktopView ? "3rem" : "auto",
    mb: desktopView && "1rem",
    my: tabletView ? "1rem" : mobileView && "1.5rem",
  };
  const challengeGroupedInfoStyle = {
    display: "flex",
    alignItems: "center",
  };
  const boxFlex = {
    display: "flex",
    alignItems: "center",
    mr: "2rem",
  };
  const infoAreaStyle = {
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    flex: 1,
    ...(currCompetition?.iteration?.id === SPONSORED_PRIZES && {
      maxWidth: "50%",
      pb: "1rem",
      "& div": {
        height: "auto",
      },
    }),
  };
  const IconStyle = {
    width: "17px",
    height: "inherit",
    color: green[2],
  };
  const compDDLStyle = {
    width: mobileView ? "100%" : tabletView ? "40%" : "20rem",
    mb: mobileView && "1rem",
    "& .MuiAutocomplete-root": {
      mb: 0,
    },
  };
  const compDDLStyleNoIter = {
    ...compDDLStyle,
    display: "flex",
    alignSelf: "flex-end",
    mr: "2rem",
  };
  const mobileCompDDLStyleNoIter = {
    width: tabletView ? "40%" : "100%",
    mb: "2rem",
  };
  const noIterBoxStyle = {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignContent: "center",
    textAlign: "center",
    height: "30%",
    padding: "1rem",
  };
  const compDescContainerStyle = {
    height: desktopView ? "108px" : "auto",
    overflow: "hidden",
  };
  const compInfoTextStyle = {
    lineHeight: 1.5,
    fontWeight: 400,
    display: "-webkit-box",
    WebkitLineClamp: desktopView ? 6 : 10,
    WebkitBoxOrient: "vertical",
    ...(!desktopView && {
      whiteSpace: "pre-line",
    }),
  };
  const bannerStyle = {
    borderRadius: desktopView ? "10px 10px 0 0" : tabletView && "10px",
    width: mobileView ? "100vw" : "100%",
    mt: mobileView && "-3.5rem",
  };
  const baseButtonStyle = {
    py: "0.5rem",
    px: 0,
    color: green[2],
    background: "transparent",
    textTransform: "none",
    fontWeight: 600,
  };
  const seeMoreButtonStyle = {
    ...baseButtonStyle,
    px: desktopView ? "0" : "0.75rem",
    color: desktopView ? green[2] : white,
    background: desktopView ? "transparent" : green[2],
  };
  const buttonBoxStyle = { mt: "auto" };

  useEffect(() => {
    if (!descRef) return;
    if (!descRef.scrollHeight) {
      setRerender(!rerender);
    }
  }, [descRef]);

  // Step 1 - current parent
  useEffect(() => {
    competitionList?.length && setCurrCompetition(competitionList[0]);
  }, [competitionList]);

  // Step 2 - current iteration of competition
  useEffect(() => {
    const getCompetitionData = async () => {
      try {
        const challengeData = await firebaseState.getSRCChallengeInfo(
          currCompetition.id,
          currCompetition.iteration.id,
          userState.profileID,
        );
        setTotalUsers(challengeData.numUsers);
        setWinnerCampData(challengeData.winners);
        setGPInfo(challengeData.campaigns.grandPrize);
        setActiveCampData(challengeData.campaigns.activeCampaigns);
        setSelfImprovementData(challengeData.campaigns.activeSelf);
        setPoolData(challengeData.campaigns.activePool);
        setBanners(challengeData.compBanner);
        setDialogInfo({
          comp: {
            title: currCompetition.title,
            description: currCompetition.iteration.description,
          },
          prize: {},
        });
      } catch (e) {
        console.error(e);
        setError(true);
      }
    };

    try {
      if (currCompetition?.id === SPONSORED_PRIZES) {
        setTotalUsers(null);
        setCurrCompetition(SponsoredPrizeCompetition);
        const getCorporateCampaignData = async () => {
          const [campaigns, winners] = await Promise.all([
            firebaseState.getCorporateCampaignsByUser(userState.profileID),
            firebaseState.getCorporateWinnersByUser(userState.profileID),
          ]);
          setWinnerCampData([winners]);
          setCorporateCampaignData(campaigns);

          setActiveCampData([]);
          setBanners(SponsoredPrizeBanners);
        };

        getCorporateCampaignData();
        return;
      }
    } catch (e) {
      console.error(e);
      setError(true);
    }
    currCompetition?.id && getCompetitionData();
  }, [currCompetition, firebaseState, userState]);

  useEffect(() => {
    if (!banners) {
      return;
    }

    let currView;
    if (mobileView) {
      currView = "mobile";
    } else if (tabletView) {
      currView = "tablet";
    } else {
      currView = "desktop";
    }

    const { challengeBanners } = banners;
    const main = challengeBanners
      ? challengeBanners[`${currView}Main`]
      : banners[currView];
    setCurrentBanners({ main, prize: banners.grandPrizeBanners });
  }, [banners, mobileView, tabletView]);

  useEffect(() => {
    reset();
  }, [currCompetition]);

  const changeCompetition = (comp) => {
    setCurrCompetition(comp);
    setError(false);
  };

  return !competitionList?.length || error ? (
    <Box id={CHALLENGES_NO_COMP_ERROR}>
      <ErrorNoCompPage
        currCompetition={currCompetition}
        setCurrCompetition={changeCompetition}
      />
    </Box>
  ) : (
    <Box sx={containerStyle}>
      <Box sx={upperBoxStyle}>
        <Box sx={challengeAreaStyle} id={CHALLENGES_MAIN_AREA}>
          {renderMainEmpty() ? (
            <>
              <Box sx={noIterBoxStyle}>
                <Typography variant="h3" sx={emptyTextStyle}>
                  {t("EmptySeasonTitle")}
                </Typography>
                <Typography variant="body1" sx={emptyTextStyle}>
                  {t("EmptySeasonDescription", {
                    parent: currCompetition?.title,
                  })}
                </Typography>
              </Box>
              {desktopView && (
                <Box sx={compDDLStyleNoIter}>
                  <CompetitionDDL
                    setCurrCompetition={setCurrCompetition}
                    currCompetition={currCompetition}
                    isDisabled={false}
                    disableLabel={!desktopView}
                    full
                    extraOptions={[SponsoredPrizeCompetition]}
                  />
                </Box>
              )}
            </>
          ) : renderMain() ? (
            <>
              {currentBanners.main && (
                <Box
                  id={"mainBanner"}
                  component="img"
                  alt={t("compBannerDesc")}
                  src={currentBanners.main}
                  sx={bannerStyle}
                />
              )}
              <ReBox style={upperContentStyle}>
                <Box sx={upperHeaderInfoStyle}>
                  {currCompetition.iteration && (
                    <Box sx={challengeGroupedInfoStyle}>
                      {Boolean(totalUsers) && (
                        <Box sx={boxFlex}>
                          <PeopleIcon sx={IconStyle} />
                          <Typography sx={textIconStyle}>
                            {totalUsers}
                          </Typography>
                        </Box>
                      )}
                      {(currCompetition.iteration?.startDate ||
                        currCompetition.iteration?.endDate) && (
                        <Box sx={boxFlex}>
                          <EventIcon sx={IconStyle} />
                          <Typography sx={textIconStyle}>
                            {`${moment(
                              currCompetition.iteration?.startDate?._seconds *
                                1000,
                            ).format("MMM D, YYYY")} - ${moment(
                              currCompetition.iteration?.endDate?._seconds *
                                1000,
                            ).format("MMM D, YYYY")}`}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  )}
                  <Box sx={compDDLStyle}>
                    <CompetitionDDL
                      setCurrCompetition={setCurrCompetition}
                      currCompetition={currCompetition}
                      isDisabled={false}
                      disableLabel={!desktopView}
                      full
                      extraOptions={[SponsoredPrizeCompetition]}
                    />
                  </Box>
                </Box>
                <Box sx={infoAreaStyle}>
                  <Typography variant="h2" sx={gpTextStyle}>
                    {currCompetition?.title}
                  </Typography>
                  <Box ref={setDescRef} sx={compDescContainerStyle}>
                    <Typography variant="body1" sx={compInfoTextStyle}>
                      {currCompetition?.iteration.description}
                    </Typography>
                  </Box>
                </Box>
                {desktopView &&
                  descRef?.scrollHeight > descRef?.clientHeight && (
                    <Box sx={buttonBoxStyle}>
                      <Button
                        sx={seeMoreButtonStyle}
                        onClick={() => {
                          setOpenDialog(0);
                        }}>
                        {t("seeMore")}
                      </Button>
                    </Box>
                  )}
              </ReBox>
            </>
          ) : (
            <LoadingWheel width={3} />
          )}
        </Box>
        {currCompetition?.iteration &&
          Object.keys(currCompetition?.iteration).length === 0 &&
          !desktopView && (
            <Box sx={mobileCompDDLStyleNoIter}>
              <CompetitionDDL
                setCurrCompetition={setCurrCompetition}
                currCompetition={currCompetition}
                isDisabled={false}
                disableLabel={!desktopView}
                full
                extraOptions={[SponsoredPrizeCompetition]}
              />
            </Box>
          )}
        <GrandPrizeArea
          gpInfo={gpInfo}
          currentBanners={currentBanners}
          renderMain={renderMain}
          renderGP={renderGP}
          rerender={rerender}
          setRerender={setRerender}
          setDialogInfo={setDialogInfo}
          setOpenDialog={setOpenDialog}
        />
      </Box>
      {currCompetition?.iteration?.id !== SPONSORED_PRIZES ? (
        (activeCampData?.length || (!poolData && !selfImprovementData)) && (
          <ChallengesDisplay
            title={
              desktopView
                ? t("weeklyCampaignTitle")
                : t("weeklyCampaignTitleMobile")
            }
            campaigns={activeCampData}
            winners={winnerCampData?.camps}
          />
        )
      ) : corporateCampaignData ? (
        Object.keys(corporateCampaignData).length ? (
          Object.entries(corporateCampaignData).map(
            ([companyName, campaigns]) => (
              <ChallengesDisplay
                key={companyName}
                title={companyName}
                campaigns={campaigns}
                winners={winnerCampData?.[0]?.[companyName] ?? []}
              />
            ),
          )
        ) : (
          <Typography variant="h3" sx={emptyTextStyle} mt="2rem">
            {t("EmptyCampDescription")}
          </Typography>
        )
      ) : (
        <ChallengesDisplay campaigns={null} />
      )}

      <SelfImprovement
        data={selfImprovementData}
        winners={winnerCampData?.weekImprovement}
      />
      {poolData && <MoneyPot data={poolData} winners={winnerCampData?.pool} />}
      {currCompetition?.iteration && gpInfo && dialogInfo && (
        <InfoModal
          open={openDialog}
          onClose={() => setOpenDialog(-1)}
          title={currCompetition.title}
          options={InfoModalButtonOptions(dialogInfo)}
        />
      )}
    </Box>
  );
};

export default CompetitionInfo;
